import { Directive, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import FormHelper from '../helpers/form.helper';
import { FormControl, FormGroup } from '@angular/forms';
import { DirtyComponent } from './dirty.component';
import { BaseComponent } from './base.component';

@Directive()
export abstract class DirtyPageComponent extends BaseComponent implements DirtyComponent, OnInit {
  public isDirty: Observable<boolean> = new Observable<boolean>(subscriber => subscriber.next(this.dirtyCheck ? this.dirtyCheck() : false));
  private dirtyCheck?: () => boolean;

  constructor() {
    super();
  }

  ngOnInit(): void {
    FormHelper.dirtyCheckBeforeUnload(this.isDirty, this);
  }

  protected initDirtyCheck(formGroup: FormGroup) {
    this.dirtyCheck = () => formGroup.dirty;
  }

  protected initDirtyCheckMultiple(formGroups: () => FormGroup[]) {
    this.dirtyCheck = () => FormHelper.dirtyCheckMultipleFormGroups(formGroups);
  }

  protected initDirtyCheckControl(formControl: FormControl) {
    this.dirtyCheck = () => formControl?.dirty ?? false;
  }
}

